/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
// Based on Marcin Wanago code
// from: https://wanago.io/2020/06/08/api-nestjs-serializing-response-interceptors/
const recursivelyStripNullValues = (value) => {
  if (Array.isArray(value)) {
    return value.map(recursivelyStripNullValues);
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, value]) => [
        key,
        recursivelyStripNullValues(value),
      ])
    );
  }
  if (value !== null) {
    return value;
  }
};

export default recursivelyStripNullValues;
